import { render, staticRenderFns } from "./UploadPDFBox.vue?vue&type=template&id=4411a680"
import script from "./UploadPDFBox.vue?vue&type=script&lang=js"
export * from "./UploadPDFBox.vue?vue&type=script&lang=js"
import style0 from "./UploadPDFBox.vue?vue&type=style&index=0&id=4411a680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports